import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, CanMatch, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";
import { CookieService } from 'ngx-cookie-service';
import {  Auth, authState } from '@angular/fire/auth';
import * as $ from 'jquery';
import { TwoFactorAuthService } from '../services/two-factor-auth.service';



@Injectable()
export class AuthGuard implements CanActivate, CanMatch {

  constructor(
    private authService: AuthService, 
    private auth: Auth, 
    private router: Router, 
    private cookieService: CookieService,
    private twoFactorService: TwoFactorAuthService
  ) {}

  canMatch(route: Route, segments: UrlSegment[]): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    throw new Error("Method not implemented.");
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.checkLogin(route,state);
  }

  canLoad(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.checkLogin(route,state);
  }

  private async checkLogin(route: ActivatedRouteSnapshot | undefined,state: RouterStateSnapshot | undefined): Promise<boolean | UrlTree> {

    if (await this.authService.isLoggedIn()) {
      let user = this.authService.getUserData();
      this.cookieService.set('token', await user?.getIdToken() as string);

      // Check 2FA requirement for admins
      try {
        const twoFAStatus = await this.twoFactorService.getStatus();
        if (twoFAStatus.enabled && !this.twoFactorService.isVerified()) {
          console.log('🔐 AuthGuard: 2FA enabled but not verified, redirecting to login');
          // Clear any existing session and redirect to login
          return this.router.parseUrl('/login');
        }
      } catch (error) {
        // If we can't check 2FA status, continue (user is probably not an admin)
        console.log('🔐 AuthGuard: Could not check 2FA status, continuing');
      }

      //get claims
      if(user) {
        let idTokenResult = await user.getIdTokenResult();

        if(idTokenResult.claims["role"]=='member'){
          // Members promoted to account admin (account_role='admin') manage
          // the team and tokens just like the owner.
          const isAccountAdmin = idTokenResult.claims["account_role"] === 'admin';

          if(state){

            if((state.url=='/members' || state.url=='/token-manager') && !isAccountAdmin){ //FORBIDDEN FOR PLAIN MEMBERS HERE!!
              console.log("FORBIDDEN FOR MEMBERS");
              this.toggleUnauthorizedNotification()
              setTimeout(() => {
                this.toggleUnauthorizedNotification()
              },3000)
              return false;
            }else{
              //console.log("ALLOWED FOR MEMBERS");
              return true;
            }
          }else{
            console.log("FORBIDDEN FOR MEMBERS");
            return false;
          }
        }else{
          //console.log("ALLOWED FOR ALL");
          return true
        }
      }

/*
      if(user){
        if(user.role=='member'){

        }else{
          return true
        }
      }else{
        return false
      }*/
      return true;


    } else {
      return this.router.parseUrl('/login');
    }

  }

  private toggleUnauthorizedNotification(){
    $("#modal-unauthorized").toggleClass("hidden");
  }
}
